/* src/app/components/processing/platform-activity/platform-activity.component.scss */
.body {
  background: #FFF;
}
.lexbe-search-wrapper {
  margin: 35px;
  position: relative;
}
.lexbe-search-wrapper .lexbe-search-input-container {
  background: #FBFBFB;
  padding: 18px 0;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.5);
  cursor: text;
  transition: background-color 250ms ease-in-out;
}
.lexbe-search-wrapper .lexbe-search-input-container:hover,
.lexbe-search-wrapper .lexbe-search-input-container:focus {
  background: #f1f1f1;
}
.lexbe-search-wrapper .lexbe-search-input-container.focus-effects {
  background: #f1f1f1;
}
.lexbe-search-wrapper .lexbe-search-input-container input {
  width: 100%;
  border: 0;
  background: none;
  outline: none;
  padding: 0 50px;
  font-family: "Roboto", sans-serif;
  font-size: 16px;
}
.lexbe-search-wrapper .lexbe-search-icon-container {
  position: absolute;
  color: #223F92;
  top: 17px;
  left: 16px;
  font-size: 16px;
}
.lexbe-search-wrapper .lexbe-clear-icon-container {
  cursor: pointer;
  position: absolute;
  color: #223F92;
  top: 17px;
  right: 25px;
  font-size: 16px;
}
:host-context(.dark-theme) .body {
  background-color: #262626;
}
:host-context(.dark-theme) .lexbe-search-wrapper .lexbe-search-input-container {
  background: #363636;
  border-color: #585858;
  border-style: solid;
  border-width: 0 1px 1px 1px;
}
:host-context(.dark-theme) .lexbe-search-wrapper .lexbe-search-input-container:hover,
:host-context(.dark-theme) .lexbe-search-wrapper .lexbe-search-input-container:focus {
  background: #424242;
}
:host-context(.dark-theme) .lexbe-search-wrapper .lexbe-search-input-container.focus-effects {
  background: #424242;
}
:host-context(.dark-theme) .lexbe-search-wrapper .lexbe-search-input-container input::placeholder {
  color: rgba(255, 255, 255, 0.6);
  opacity: 1;
}
:host-context(.dark-theme) .lexbe-search-wrapper .lexbe-search-input-container input {
  color: #eaeaea;
}
:host-context(.dark-theme) .lexbe-search-wrapper .lexbe-search-icon-container,
:host-context(.dark-theme) .lexbe-search-wrapper .lexbe-clear-icon-container {
  color: #88a3ff;
}
:host-context(.dark-theme) .mat-mdc-tab-header {
  border-bottom: 1px solid rgba(255, 255, 255, 0.25);
}
/*# sourceMappingURL=platform-activity.component.css.map */
